import Select, { components } from "react-select";
import Buscar from "../../assets/img/svg/buscar.svg";

const CustomControl = (iconSrc) => (props) =>
  (
    <components.Control {...props}>
      <img
        src={iconSrc}
        alt="icon"
        style={{
          width: 12,
          height: 12,
          marginLeft: 8,
          marginRight: 5,
          flexShrink: 0,
        }}
      />
      {props.children}
    </components.Control>
  );

const DropdownCaret = (props) => {
  const { menuIsOpen } = props.selectProps;
  return (
    <components.DropdownIndicator {...props}>
      <span
        style={{
          display: "inline-block",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "6px solid #62C776",
          transform: menuIsOpen ? "rotate(180deg)" : "none",
          transition: "transform 120ms ease",
          marginRight: 6,
          marginTop: 6,
        }}
      />
    </components.DropdownIndicator>
  );
};

export default function ButtonStyledSelect({
  options,
  value,
  onChange,
  isMulti = true,
  placeholder = "Filtrar por estatus",
  iconSrc = Buscar,
}) {
  return (
    <div style={{ width: "auto" }}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        placeholder={placeholder}
        classNamePrefix="react-select"
        components={{
          Control: CustomControl(iconSrc),
          DropdownIndicator: DropdownCaret,
        }}
        styles={{
          control: (base, state) => ({
            ...base,
            background: "#FFFFFF",
            border: "0.5px solid #C3C3C3",
            borderRadius: 5,
            minHeight: 31,
            height: 38,
            boxShadow: "none",
            cursor: "pointer",
            fontFamily: "Nunito",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: 14,
            lineHeight: "19px",
            textAlign: "left",
            ...(state.isFocused
              ? { borderColor: "#C3C3C3" }
              : { borderColor: "#C3C3C3" }),
            "&:hover": { borderColor: "#C3C3C3" },
          }),
          valueContainer: (base) => ({ ...base, padding: "0 8px" }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontFamily: "Nunito, sans-serif",
          }),
          placeholder: (base) => ({
            ...base,
            color: "#223D51",
            opacity: 0.9,
            fontFamily: "Nunito",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#223D51",
            fontFamily: "Nunito",
          }),
          // Chips multi
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#F2F6F8",
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "#223D51",
            fontWeight: 700,
            fontFamily: "Nunito",
          }),
          // Tache (X) en #223D51
          multiValueRemove: (base) => ({
            ...base,
            color: "#223D51",
            ":hover": {
              backgroundColor: "transparent",
              color: "#223D51",
            },
            "& svg": { fill: "#223D51" },
            "&:hover svg": { fill: "#223D51" },
          }),
          dropdownIndicator: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 4,
            paddingRight: 8,
          }),
          clearIndicator: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
          }),
          indicatorsContainer: (base) => ({ ...base, height: 31 }),
          indicatorSeparator: () => ({ display: "none" }),
          menu: (base) => ({
            ...base,
            borderRadius: 6,
            overflow: "hidden",
            textAlign: "left",
          }),
          // Opciones del menú con Nunito
          option: (base, state) => ({
            ...base,
            fontFamily: "Nunito",
            color: "#000",
            textAlign: "left",
            backgroundColor: state.isSelected ? "#e0e0e0" : "#fff",
            ":hover": { backgroundColor: "#F2F2F2" },
          }),
        }}
      />
    </div>
  );
}
